import React from "react";
import { CreditCard, Banknote } from "lucide-react";

export default function PaymentBadge({ method }) {
  const isCod = method === "cod";
  if (method !== "cod" && method !== "prepaid") {
    return <span className="text-xs text-muted-foreground" data-testid="payment-badge-none">—</span>;
  }
  const Icon = isCod ? Banknote : CreditCard;
  return (
    <span
      data-testid={`payment-badge-${isCod ? "cod" : "prepaid"}`}
      className={`inline-flex items-center gap-1 text-[11px] font-semibold rounded-full px-2 py-0.5 whitespace-nowrap ${
        isCod ? "bg-[#FBEFD9] text-[#8A6D1F]" : "bg-[#E3F0E5] text-[#1E7A34]"
      }`}
    >
      <Icon className="h-3 w-3 shrink-0" /> {isCod ? "COD" : "Prepaid"}
    </span>
  );
}
